import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationUnread } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export const useEventConversationUnread = (callHistoryStore: CallHistoryStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseConversationUnread) => {
    if (data.conversation.unread_count === 0) {
      callHistoryStore.syncFilters()
      callHistoryStore.markAsReadByConversation(data.conversation_id, data.inbox_id)
    } else if (data.conversation.unread_count > 0) {
      if (data.read_messages.length) {
        callHistoryStore.callHistoryFiltersStore.decreaseCount(data.read_messages)
      }
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationUnread, handler), [])
}
